import { getVisibleSiteBaseUrl } from "@/modules/main/urls.ts";
import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";
import type { Store } from "@/utils/jotai/types.ts";
import { useOnce } from "@/utils/react/useOnce.ts";
import { useStore } from "jotai/react";
import { atom } from "jotai/vanilla";

export function getReferralUrl(referralShareCode: string) {
    const siteBaseUrl = getVisibleSiteBaseUrl();
    // NB: does not include the base path (it is handled by an external redirect)
    return `${siteBaseUrl}/referral/${referralShareCode}`;
}

export const referralCodeAtom = atomWithLocalStorage<string | undefined>("referralCode", undefined);
/** Was the referral code stored for this page load? */
export const didStoreReferralCodeAtom = atom(false);

function setReferralCodeFromLocation(store: Store) {
    const query = new URLSearchParams(window.location.search);
    const referralCode = query.get("referral_code");

    if (referralCode) {
        console.debug("Setting referral code from query parameter: %o", referralCode);

        store.set(didStoreReferralCodeAtom, true);
        store.set(referralCodeAtom, referralCode);
    }
}

export function useStoreReferralCode() {
    const store = useStore();
    // NB: Must run this effect in render phase because other components depend on the other atoms this effect sets
    useOnce(() => {
        setReferralCodeFromLocation(store);
    });
}
